const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getCarbonFactors(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.territory) params.append('territory', filters.territory);
  if (filters.year) params.append('year', filters.year);
  if (filters.factorType) params.append('factorType', filters.factorType);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/carbon/factors${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch carbon factors');
  }
  
  const data = await response.json();
  return data.factors;
}

export async function getCarbonFactor(orgId, factorId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/carbon/factors/${factorId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch carbon factor');
  }
  
  const data = await response.json();
  return data.factor;
}

export async function createCarbonFactor(orgId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/carbon/factors`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    throw new Error('Failed to create carbon factor');
  }
  
  const result = await response.json();
  return result.factor;
}

export async function updateCarbonFactor(orgId, factorId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/carbon/factors/${factorId}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    throw new Error('Failed to update carbon factor');
  }
  
  const result = await response.json();
  return result.factor;
}

export async function lookupCarbonFactor(orgId, territory, year, factorType) {
  const params = new URLSearchParams({
    territory,
    year: year.toString(),
    factorType
  });
  
  const response = await fetch(`${API_BASE}/orgs/${orgId}/carbon/lookup?${params}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw new Error('Failed to lookup carbon factor');
  }
  
  const data = await response.json();
  return data.factor;
}
